import { z } from 'zod';
import { estimatingEstimateResponseSchema, estimatingEstimateTierSchema } from './estimating-estimate.contract.js';
export const estimatingProposalPackagesCapability = 'estimating.proposal-packages.v1';
const reason = z.string().trim().min(10).max(500);
export const estimatingDuplicateEstimateCommandSchema = z.strictObject({
    kind: z.literal('duplicate'),
    commandId: z.string().uuid(),
    estimateId: z.string().uuid(),
    reason,
});
export const estimatingProposalPackageEstimateRequestSchema = z.strictObject({
    tierCode: estimatingEstimateTierSchema,
    estimateId: z.string().uuid(),
    commandId: z.string().uuid(),
});
export const estimatingGenerateProposalPackageCommandSchema = z.strictObject({
    kind: z.literal('generate'),
    commandId: z.string().uuid(),
    packageId: z.string().uuid(),
    sourceEstimateId: z.string().uuid(),
    expectedSourceRevision: z.number().int().positive(),
    estimates: z.array(estimatingProposalPackageEstimateRequestSchema).min(1).max(3),
    replaceExistingDrafts: z.boolean().default(true),
    reason,
}).superRefine((value, context) => {
    const tiers = value.estimates.map(({ tierCode }) => tierCode);
    const estimateIds = value.estimates.map(({ estimateId }) => estimateId);
    const commandIds = value.estimates.map(({ commandId }) => commandId);
    for (const [path, entries] of [['estimates.tierCode', tiers], ['estimates.estimateId', estimateIds], ['estimates.commandId', commandIds]]) {
        if (new Set(entries).size !== entries.length) {
            context.addIssue({ code: 'custom', path: path.split('.'), message: 'Proposal package entries must be unique.' });
        }
    }
});
export const estimatingProposalPackageSchema = z.strictObject({
    contractVersion: z.literal(estimatingProposalPackagesCapability),
    tenantId: z.string().uuid(),
    id: z.string().uuid(),
    projectId: z.string().uuid(),
    sourceEstimateId: z.string().uuid(),
    sourceVersionId: z.string().uuid(),
    sourceRevision: z.number().int().positive(),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    members: z.array(z.strictObject({
        tierCode: estimatingEstimateTierSchema,
        estimateId: z.string().uuid(),
        estimateVersionId: z.string().uuid(),
        estimateNumber: z.string().trim().min(1).max(80),
        totalCents: z.number().int().min(0).max(999_999_999_999),
    })).min(1).max(3),
    replacedEstimateIds: z.array(z.string().uuid()),
    actorMembershipId: z.string().uuid(),
    createdAt: z.string().datetime({ offset: true }),
});
export const estimatingDuplicateEstimateResponseSchema = estimatingEstimateResponseSchema;
export const estimatingProposalPackageResponseSchema = z.strictObject({
    data: estimatingProposalPackageSchema,
    estimates: z.array(estimatingEstimateResponseSchema.shape.data),
    command: z.strictObject({ commandId: z.string().uuid(), idempotent: z.boolean() }),
});
export const estimatingProposalPackageListQuerySchema = z.strictObject({
    projectId: z.string().uuid().nullable().default(null),
    limit: z.number().int().min(1).max(250).default(50),
    offset: z.number().int().nonnegative().default(0),
});
export const estimatingProposalPackagesResponseSchema = z.strictObject({
    data: z.array(estimatingProposalPackageSchema),
    page: z.strictObject({
        limit: z.number().int().positive(),
        offset: z.number().int().nonnegative(),
        returned: z.number().int().nonnegative(),
        total: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=estimating-proposal-package.contract.js.map